import axios from "axios";
import { logDetailed } from "../../helpers/utils";

export default {
    methods: {
        // upload a set of files to the server
        // return a promise representing the completion of all file uploads
       uploadExamFiles(patient) {
            var promises = [];
            var indexes = [];
            for (let i = 0; i < patient.files.length; i++) 
                indexes.push(i);
                
            // reducer ensures that the promises will be executed sequentially
            // https://css-tricks.com/why-using-reduce-to-sequentially-resolve-promises-works/
            return indexes.reduce(
                async (p, i) =>  {
                    return p.then(() => {
                        promises.push(this.submitExamFile(patient, i));
                        return promises[i];
                    });
                }, Promise.resolve())
                .then(() => {
                    return Promise.all(promises);
                });
        },
        // submit an individual image to the server
        // as the file goes through various workflow states, update the state of the file
        submitExamFile(patient, index) {
            const file = patient.files[index];
            this.updateFileState(file, index, patient.files, "In Progress");

            var fd = new FormData();
            fd.append("image", file);
            fd.append("ptSrNo", patient.ptSrNo);
            fd.append("exSrNo", patient.exam.exSrNo);
            fd.append("index", index + 1);
            fd.append("eye", file.eye);

            return axios.post("api/image/saveExamImage", fd, {
                headers: { "Content-Type": "multipart/form-data" },
                onUploadProgress: (progressEvent) => {
                    // callback reports how much data has been sent to the server
                    if (progressEvent.lengthComputable) {
                        file.uploaded = progressEvent.loaded;
                        const finishedState = file.uploaded == progressEvent.total ? "Uploaded" : "";
                        this.updateFileState(file, index, patient.files, finishedState);
                    }
                }
            }).then(response => {
                logDetailed("UploadExamFiles", "submitExamFile", "File upload response", response);
                let success = response.data && response.data.success;
                let state = success ? "Completed" : "Error";
                file.state = state;
                this.updateFileState(file, index, patient.files, state);
                return response;
            }).catch(response => {
                logDetailed("UploadExamFiles", "submitExamFile", "File upload failed", response);
                file.state = "Error";
                this.updateFileState(file, index, patient.files, "Error");
                return response;
            });
        },
        // vue can't detect property changes to array elements
        // this method sets the current file to itself in a way that notifies vue about the change
        updateFileState(file, index, files, state) {
            file.state = state || file.state;
            this.$set(files, index, file);
        },

        batchEditEyeType(files, batchEyeType) {
            for (let i = 0; i < files.length; i++) {
                if (files[i].batchEyeSelected) {
                    files[i].eye = batchEyeType;
                    this.$set(files, i, files[i]);
                }
            }
        }
    }
}